import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import LogoText from 'assets/svg/logo.svg';
import LogoTextMobile from 'assets/svg/logomobile .svg';
import Media from 'react-media';
import cn from 'classnames';

import classes from './Logo.module.scss';

const Logo = ({ className, guestMode }) => {
  const logoPicture = () => {
    return (
      <Media
        queries={{
          small: '(max-width: 1279px)',
          large: '(min-width: 1280px)'
        }}
      >
        {matches => (
          <>
            {matches.small && (
              <img
                src={LogoTextMobile}
                className={classes.logomobile}
                alt="Link to the home page"
                width="42"
                height="40"
              />
            )}
            {matches.large && (
              <img
                src={LogoText}
                className={classes.logo}
                alt="Link to the home page"
                width="96"
                height="16"
              />
            )}
          </>
        )}
      </Media>
    );
  };

  return (
    <>
      {!guestMode ? (
        <Link to={'/groups'} className={cn(classes.logoWrap, className)}>
          {logoPicture()}
        </Link>
      ) : (
        logoPicture()
      )}
    </>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  guestMode: PropTypes.bool
};

export default Logo;
